import { graphql } from "../../../models/autogenerated-deliveryService-gql";

export const CreateOutboundDeliveryMutation = graphql(/* GraphQL */ `
  mutation CreateOutboundDelivery($input: CreateOutboundDeliveryInput!) {
    createOutboundDelivery(input: $input) {
      outboundDeliveryDetail {
        id
        deliveryNumber
        status
        itemCount
        items {
          id
          itemNumber
          materialId
          owner
          quantities {
            outboundDeliveryItemQuantityId
            quantityRole
            quantityRoleCategory
            quantity
            unitOfMeasurement
          }
        }
        partners {
          outboundDeliveryPartnerId
          businessPartnerId
          businessPartnerNumber
          companyName
          role
        }
        times {
          outboundDeliveryTimeId
          type
          category
          date
          time
        }
      }
    }
  }
`);
